import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (payload) => {
    const result = await axiosPublicClient.post(`/consent-resign-status`, payload)
    return result.data
}

export default service
